import { Controller } from "@hotwired/stimulus"

const INTERVAL_MS = 10_000
const WINDOW_MINUTES = 5

// Polls for new logs by re-submitting the search form every INTERVAL_MS,
// automatically setting the time range to the last WINDOW_MINUTES minutes.
export default class extends Controller {
  static targets = ["trigger", "indicator"]

  #timer = null
  #countdownTimer = null
  #active = false
  #secondsLeft = 0

  disconnect() { this.#deactivate() }

  toggle() {
    this.#active ? this.#deactivate() : this.#activate()
  }

  #activate() {
    this.#active = true
    this.triggerTarget.classList.add("active")
    this.#tick()
    this.#secondsLeft = INTERVAL_MS / 1000
    this.#timer = setInterval(() => this.#tick(), INTERVAL_MS)
    this.#countdownTimer = setInterval(() => {
      this.#secondsLeft = Math.max(0, this.#secondsLeft - 1)
      if (this.#secondsLeft === 0) this.#secondsLeft = INTERVAL_MS / 1000
      this.#updateIndicator()
    }, 1000)
  }

  #deactivate() {
    this.#active = false
    clearInterval(this.#timer)
    clearInterval(this.#countdownTimer)
    this.#timer = null
    this.#countdownTimer = null
    if (this.hasTriggerTarget) this.triggerTarget.classList.remove("active")
    if (this.hasIndicatorTarget) this.indicatorTarget.textContent = ""
    document.querySelector("[data-siem-search-form]")?.querySelector("[name='live_tail']")?.remove()
  }

  #tick() {
    const now = new Date()
    const start = new Date(now - WINDOW_MINUTES * 60_000)
    const form = document.querySelector("[data-siem-search-form]")
    if (!form) return
    const rangeInput = form.querySelector("[name='time_range']")
    if (rangeInput) rangeInput.value = `${start.toISOString()} - ${now.toISOString()}`
    let liveTailFlag = form.querySelector("[name='live_tail']")
    if (!liveTailFlag) {
      liveTailFlag = document.createElement("input")
      liveTailFlag.type = "hidden"
      liveTailFlag.name = "live_tail"
      form.appendChild(liveTailFlag)
    }
    liveTailFlag.value = "1"
    form.requestSubmit()
  }

  #updateIndicator() {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.textContent = this.#active ? `${this.#secondsLeft}s` : ""
    }
  }
}
